<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elevation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                    <v-spacer></v-spacer>
                </v-toolbar>
            </v-card>
            <app-pages :app_id="pageIds.finance"></app-pages>
        </v-flex>

    </v-layout> 
</template>

<script>
import pageIds from '@/constants/app_ids'

export default {     
    name: 'FinanceMenu',
    metaInfo: {
        title: 'Finance Menu',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'Finance Menu' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {
        'app-pages': ()=> import('@/components/Common/PageMenu')
    },   
    data () {
        return {
            pageIds,
            error: false,
            errorMessage: '',
            loading: false,
        }
    },
    async created() {
        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            isMainMenu: true,
            headerTitle: 'Finance',
            headerPageTitle: 'Menu'
        })
    }
}
</script>